var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChalkboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M552 432H416V384C416 366.326 401.674 352 384 352H256C238.326 352 224 366.326 224 384V432H24C10.746 432 0 442.744 0 456C0 469.254 10.746 480 24 480H552C565.254 480 576 469.254 576 456C576 442.744 565.254 432 552 432ZM368 432H272V400H368V432ZM80 88C80 83.594 83.594 80 88 80H488C492.406 80 496 83.594 496 88V400H544V88C544 57.125 518.875 32 488 32H88C57.125 32 32 57.125 32 88V400H80V88Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChalkboard);
export default __webpack_public_path__ + "static/media/chalkboard.0110a28bf8c7c95d9b252725a8809e04.svg";
export { ForwardRef as ReactComponent };